export function getProjectFieldSettingsVariables(billingType, settings) {
  const fieldSettings = settings || {};

  if (billingType === "Hundredweight") {
    fieldSettings.receiving_report_number = true;
    fieldSettings.item_id = true;
    fieldSettings.weight = true;
    fieldSettings.available_quantity = true;
    fieldSettings.warehouse_quantity = true;
    fieldSettings.rack_locations = true;
    fieldSettings.total_weight = true;
    fieldSettings.total_receiving_units = true;
  } else if (billingType === "By the Pallet") {
    fieldSettings.receiving_report_number = true;
    fieldSettings.item_id = true;
    fieldSettings.pallet_type = true;
    fieldSettings.available_quantity = true;
    fieldSettings.warehouse_quantity = true;
    fieldSettings.rack_locations = true;
    fieldSettings.total_receiving_units = true;
  } else if (["Square Foot", "Cubic Foot"].includes(billingType)) {
    fieldSettings.receiving_report_number = true;
    fieldSettings.item_id = true;
    fieldSettings.dimensions = true;
    fieldSettings.available_quantity = true;
    fieldSettings.warehouse_quantity = true;
    fieldSettings.rack_locations = true;
    fieldSettings.total_receiving_units = true;
  }
  return fieldSettings;
}

export function getProjectVariables(values) {
  const { addresses = [] } = values;
  const settings = { ...(values.settings || {}) };
  const inProgressNotifications = settings.in_progress_shipment_notifications;

  if (inProgressNotifications) {
    settings.in_progress_shipment_notifications = {
      ...inProgressNotifications,
      timezone: inProgressNotifications.timezone || null,
      times: Array.isArray(inProgressNotifications.times) ? inProgressNotifications.times : [],
    };
  }

  return {
    id: values.id,
    name: values.name,
    disabled: !values.active,
    storageEnabled: values.storageEnabled,
    settings,
    fieldSettings: values.fieldSettings,
    projectType: values.projectType,
    customerOwner: values.customerOwner,
    customerNotes: values.customerNotes,
    escalationEmailSendList: values.escalationEmailSendList,
    contactName: values.contactName,
    contactEmail: values.contactEmail,
    contactPhoneNumber: values.contactPhoneNumber,
    customerEmailSendList: values.customerEmailSendList,
    osDEmailSendList: values.osDEmailSendList,
    billingEmailSendList: values.billingEmailSendList,
    outboundOnlyEmailSendList: values.outboundOnlyEmailSendList,
    deliveryOnlyEmailSendList: values.deliveryOnlyEmailSendList,
    approvedEmailSendList: values.approvedEmailSendList,
    automatedReportsEmailSendList: values.automatedReportsEmailSendList,
    billingMethod: values.billingMethod,
    billingDate: values.billingDate,
    billingAnchorDate: values.billingAnchorDate,
    billingNotes: values.billingNotes,
    importedAssets: values.importedAssets,
    orderNumber: values.orderNumber,
    customerPoNumber: values.customerPoNumber,
    referenceAssets: values.referenceAssets,
    shipmentItemUnitBreakdown: values.shipmentItemUnitBreakdown,
    billing: values.billing,
    kitting: values.kitting,
    groupedAssets: values.groupedAssets,
    groupedSerializedAssets: values.groupedSerializedAssets,
    receivingWizardBillingStep: values.receivingWizardBillingStep,
    addPreviouslyReceivedAssetsToShipments: values.addPreviouslyReceivedAssetsToShipments,
    allowExternalUsersToCreateInternalOrders: values.allowExternalUsersToCreateInternalOrders,
    allowExternalUsersToEditOrders: values.allowExternalUsersToEditOrders,
    minimumAssetImages: values.minimumAssetImages,
    minimumShipmentImages: values.minimumShipmentImages,
    shipmentItemPdfPreferences: values.shipmentItemPdfPreferences,
    addresses: addresses.map(({ __typename, ...address }) => address),
  };
}
